import React from "react";
import MessageRow from "./MessageRow";
import FollowUpQuestions from "./FollowUpQuestions";

const ChatItem = ({ content, isLast, brainId, chatId, onQuestionSent, setIsLoading }) => {
    if (!content) return null;
    const { user_message, assistant, metadata } = content;

    return (
        <>
            <MessageRow speaker="user" text={user_message} />
            <MessageRow speaker="assistant" text={assistant} metadata={metadata} isLast={isLast} />
            {metadata?.followup_questions?.length > 0 && (
                <FollowUpQuestions
                    questions={metadata.followup_questions}
                    chatId={chatId}
                    brainId={brainId}
                    onQuestionSent={onQuestionSent}
                    setIsLoading={setIsLoading}
                />
            )}
        </>
    );
};

export default ChatItem;
